/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function EyeOff({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M2.424 1.576a.6.6 0 1 0-.848.848l2.227 2.228a8.96 8.96 0 0 0-2.698 2.825 1.02 1.02 0 0 0 0 1.045C1.62 9.394 3.797 12.6 8 12.6a7.5 7.5 0 0 0 3.1-.65l2.476 2.474a.6.6 0 1 0 .848-.848zm7.755 9.451L9.075 9.924a3.35 3.35 0 0 1-4.249-4.249l-.153-.154C3.328 6.335 2.516 7.473 2.19 8c.547.887 2.403 3.4 5.809 3.4a6.4 6.4 0 0 0 2.179-.373M5.85 6.7l-.001.051a2.15 2.15 0 0 0 2.2 2.15z" clipRule="evenodd" /><path fill="currentColor" d="M7.4 4a.6.6 0 0 1 .6-.6c4.202 0 6.379 3.206 6.896 4.078.193.327.189.725-.002 1.046-.2.337-.617.973-1.273 1.645a.6.6 0 1 1-.858-.838A8 8 0 0 0 13.809 8c-.353-.572-1.25-1.821-2.758-2.636.192.423.299.892.299 1.386 0 .429-.08.84-.229 1.218a.6.6 0 1 1-1.117-.436A2.15 2.15 0 0 0 8 4.6a.6.6 0 0 1-.6-.6" /></svg>;
}
;